import { hasOwnNestedProperty, normalizeValue } from '../helpers.js';

export default {
  getVisitorId: state => {
    return state.visitorId;
  },
  getLang: state => {
    return state.lang;
  },
  getLastHttpAction: state => {
    return state.lastHttpAction;
  },
  getHasStarted: state => {
    return state.stationStartTimestamp ? true : false;
  },
  
  getShowLoading: state => {
    return state.showLoadindicator;
  },
  getDataLoadError: state => {
    return state.dataLoadError;
  },

  getStationIntroTrack: state => {
    if (state.cmsData)
      return state.cmsData.intro_track;
  },
  getStationHeading: state => {
    if (state.cmsData)
      return state.cmsData.heading;
  },
  getStationScrrenState: state => {
      return state.screenState;
  },
  getStationIntro: state => {
    if (state.cmsData)
      return state.cmsData.intro_text;
  },
  getEndScreenInfoPageId: state => {
    if (state.cmsData)
      return state.cmsData.infobutton_end_screen;
  },
  
  getCurrentLevel: state => {
    if (hasOwnNestedProperty(state, `cmsData.levels.${state.currentLevelIndex}`))
      return state.cmsData.levels[state.currentLevelIndex];
  },
  getCurrentLevelOptions: state => {
    if (hasOwnNestedProperty(state, `cmsData.levels.${state.currentLevelIndex}.options`))
      return state.cmsData.levels[state.currentLevelIndex]['options'];
  },
  getTotalLevels: state => {
    if (hasOwnNestedProperty(state, 'cmsData.levels'))
      return state.cmsData.levels.length;
  },
  getCurrentLevelStatistics: state => {
    return state.levelStatistics.find(item => item.levelId == state.currentLevelIndex);
  },
  getCurrentLevelIndex: state => {
    return state.currentLevelIndex;
  },
  getCurrentLevelInfoPageId: state => {
    if (hasOwnNestedProperty(state, `cmsData.levels.${state.currentLevelIndex}.infobutton`))
      return state.cmsData.levels[state.currentLevelIndex]['infobutton'];
  },
  getCurrentLevelVoiceover: state => {
    if (hasOwnNestedProperty(state, `cmsData.levels.${state.currentLevelIndex}.voiceover`))
      return state.cmsData.levels[state.currentLevelIndex]['voiceover'];
  },
  getQuizinstruction: state => {
    if (state.cmsData)
      return state.cmsData.quiz_instruction;
  },
  getIsLevelEnd: state => {
    return state.isLevelEnd;
  },
  getGlobalAudioState: state => {
    return state.playAudio;
  },

  getCurrentLevelStats: state => {
    const currentLevel = state.currentLevelIndex;
    if (state.levelStatistics.length >= currentLevel + 1)
      return state.levelStatistics[currentLevel];
    else
      return null;
  },
  getStatisticsTotals: state => {
    let total = 0,
        correct = 0,
        wrong = 0,
        duration = 0,
        clicks = 0;

    state.levelStatistics.map(level => {
      total += level.totalCorrectAnswers;
      wrong += level.wrongAnswered;
      correct += level.correctAnswered;
    });

    if (state.stationStartTimestamp && state.stationEndTimestamp) {
      duration = state.stationEndTimestamp - state.stationStartTimestamp
    }

    clicks = state.clickCount;

    const normalized = {
      score: normalizeValue(correct - wrong, 0, total), 
      duration: normalizeValue(duration, 0, 600000), // 0 – 10 minutes
      activity: normalizeValue(clicks, 0, 50),
    }

    return { correct, wrong, normalized };
  },
  getFeedbackVoiceovers: state => {
    if (state.cmsData)
      return [
        state.cmsData.feedback_01,
        state.cmsData.feedback_02,
        state.cmsData.feedback_03,
        state.cmsData.feedback_04
      ];
  },
};